import { render, staticRenderFns } from "./liveClassManagement.vue?vue&type=template&id=bd06765c&scoped=true"
import script from "./liveClassManagement.vue?vue&type=script&lang=js"
export * from "./liveClassManagement.vue?vue&type=script&lang=js"
import style0 from "./liveClassManagement.vue?vue&type=style&index=0&id=bd06765c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd06765c",
  null
  
)

export default component.exports